import { atom } from 'recoil';

export const currentListIdState = atom<string | undefined>({
  key: 'currentListIdState',
  default: undefined,
});

export default currentListIdState;
